// api/biometriaApi.js
// API para validación biométrica

import axios from "axios"

const API_BASE = window.REACT_APP_URL || ""
const BASE_PATH = `${API_BASE}/ewanapi/v1/onboarding/biometria`

/**
 * Valida la biometría de un firmante
 *
 * @param {Object} datos - Datos del firmante
 * @param {string} datos.numeroDocumento - Número de documento
 * @param {string} datos.tipoDocumento - Tipo de documento (DNI, etc)
 * @param {string} datos.sexo - Sexo (M/F)
 * @param {string} datos.nombre - Nombre
 * @param {string} datos.apellido - Apellido
 * @param {string} datos.imagenBase64 - Imagen selfie en base64
 * @param {string} datos.cuit - CUIT de la empresa
 * @returns {Promise<Object>} Resultado de la validación
 */
export const validarBiometria = async datos => {
  try {
    const response = await axios.post(`${BASE_PATH}/validar`, datos)
    return response.data
  } catch (error) {
    console.error("Error en validación biométrica:", error)
    return {
      exitoso: false,
      estado: "ERROR",
      mensaje: error.response?.data?.mensaje || "Error de conexión",
      codigoError: error.response?.data?.codigoError || "CONEXION_ERROR",
    }
  }
}

/**
 * Obtiene el estado de biometría de un documento
 *
 * @param {string} numeroDocumento - Número de documento
 * @returns {Promise<Object>} Estado de biometría
 */
export const obtenerEstadoBiometria = async numeroDocumento => {
  try {
    const response = await axios.get(`${BASE_PATH}/estado/${numeroDocumento}`)
    return response.data
  } catch (error) {
    console.error("Error obteniendo estado biometría:", error)
    return {
      numeroDocumento,
      estado: "PENDIENTE",
      intentos: 0,
    }
  }
}

/**
 * Reinicia el estado de biometría para permitir reintentos
 *
 * @param {string} numeroDocumento - Número de documento
 * @returns {Promise<Object>} Resultado
 */
export const reiniciarBiometria = async numeroDocumento => {
  try {
    const response = await axios.post(
      `${BASE_PATH}/reiniciar/${numeroDocumento}`,
    )
    return response.data
  } catch (error) {
    console.error("Error reiniciando biometría:", error)
    return { success: false, error: error.message }
  }
}

/**
 * Verifica que el servicio de biometría esté disponible
 *
 * @returns {Promise<boolean>} True si está disponible
 */
export const verificarServicioBiometria = async () => {
  try {
    const response = await axios.get(`${BASE_PATH}/health`)
    return response.data?.status === "UP"
  } catch (error) {
    console.error("Servicio de biometría no disponible:", error)
    return false
  }
}

export default {
  validarBiometria,
  obtenerEstadoBiometria,
  reiniciarBiometria,
  verificarServicioBiometria,
}
